import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import api from '@/shared/api';
import OkCancelModal from '@/shared/components/OkCancelModal';
import FormattedDateShort from '@/shared/components/FormattedDateShort';
import handleHttpError from '@/shared/services/HandleHttpError';
const messages = defineMessages({
    UpdateNaceCodes: { id: 'UpdateNaceCodes', defaultMessage: 'Update NACE codes' },
    UpdateNaceCodesDescription: {
        id: 'UpdateNaceCodesDescription',
        defaultMessage: 'The NACE codes of the selected relations will be updated with the data from the KBO.',
    },
    KboSnapshotDate: { id: 'KboSnapshotDate', defaultMessage: 'KBO snapshot date' },
});
const UpdateRelationNaceCodesModal = ({ onSave, onClose, }) => {
    const intl = useIntl();
    const [snapshotDate, setSnapshotDate] = useState(null);
    useEffect(() => {
        api.base
            .get('/api/externalRelation/KboSnapshotDate')
            .then(({ data }) => setSnapshotDate(data))
            .catch(handleHttpError(intl));
    }, [intl]);
    return (_jsxs(OkCancelModal, Object.assign({ title: intl.formatMessage(messages.UpdateNaceCodes), show: true, onClose: onClose, onSave: onSave }, { children: [_jsx("p", { children: intl.formatMessage(messages.UpdateNaceCodesDescription) }), snapshotDate && (_jsxs("p", { children: [intl.formatMessage(messages.KboSnapshotDate), ":", ' ', _jsx(FormattedDateShort, { value: snapshotDate })] }))] })));
};
export default UpdateRelationNaceCodesModal;
